import React, { useState, useRef, useEffect } from 'react';
import { FormControl, FormHelperText, CircularProgress, TextField, Container, Typography, InputLabel, Paper, Toolbar, Select, MenuItem, Divider, Radio, RadioGroup, Button, Grid, Box, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from 'redux';
import { useForm, Controller } from "react-hook-form";
import SaveIcon from '@material-ui/icons/Save';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { TerminalActions, NotificationActions } from '../../../store';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px'
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const terminalsSelector = (state) => state.Terminals;
const IdentitySelector = (state) => state.Identity;

const TerminalEdit = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const terminalActions = bindActionCreators(TerminalActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(terminalsSelector);
    const { token, userData } = useSelector(IdentitySelector);

    // React Hook Form
    const { control, errors, handleSubmit, watch } = useForm();
    const password = useRef({});
    password.current = watch("password", "");

    const { classes } = props;

    // 端末タイプ（変更時にコントロールの切り替え）
    const [terminalType, setTerminalType] = React.useState(0);

    // 機器設置時識別番号の使用中確認ダイアログ
    const [conflictDlgOpen, setConflictDlgOpen] = useState(false);
    const [conflictInfo, setConflictInfo] = useState(null);
    // 強制切替の実施は、常にSystemAdmin(1)・Brand(2)のみ許可
    const isForceSwitchAllowed = userData.role == 1 || userData.role == 2;

    /**
     *
     * エラーメッセージが機器設置時識別番号の使用中確認情報（JSON）かどうかを判定し、
     * 該当する場合はパース結果を返します（該当しない場合はnullを返します）。
     *
     */
    const tryParseConflictInfo = (message) => {
        if (!message) {
            return null;
        }
        try {
            const parsed = JSON.parse(message);
            if (parsed && parsed.install_id && Array.isArray(parsed.conflicts)) {
                return parsed;
            }
        } catch (ex) {
            // JSONでない場合は通常のエラーメッセージとして扱う
        }
        return null;
    }

    /**
     * 
     * 戻る押下時の処理
     * 
     */
    const onBackClick = () => {
        props.onCancel();
    }

    /**
     * 
     * 保存ボタン押下時の処理
     * 
     */
    const onSubmit = (data, e) => {
        editing.is_force_switch = false;
        terminalActions.save(token, editing)
            .then(data => {
                notificationActions.showSuccess('登録しました。');
                props.onCancel();
            })
            .catch(e => {
                const parsed = tryParseConflictInfo(e.message);
                if (parsed) {
                    setConflictInfo(parsed);
                    setConflictDlgOpen(true);
                } else {
                    notificationActions.showError(e.message);
                }
            });
    }

    /**
     *
     * 強制切替実施ボタン押下時の処理
     *
     */
    const onForceSwitchClick = () => {
        setConflictDlgOpen(false);
        editing.is_force_switch = true;
        terminalActions.save(token, editing)
            .then(data => {
                notificationActions.showSuccess('登録しました。');
                props.onCancel();
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     *
     * 使用中確認ダイアログ「キャンセル」押下時の処理
     *
     */
    const onConflictDlgCancelClick = () => {
        setConflictDlgOpen(false);
        setConflictInfo(null);
    }

    // 設置フラグ
    var disIsInstalled = editing.terminal_type == 1 ? false : true;
    /**
     *
     * 入力内容変更時の処理
     *
     */
    const onChange = (e) => {
        const currentState = editing;
        const { name, value } = e[0].target;

        currentState[name] = value;

        if (name.startsWith('shop_id')) {
            if (value == null || value == '') {
                currentState['shop_name'] = '';
            }
            else {
                const shop = editing.selectableShops.find(shop => shop.id === value);
                currentState['shop_name'] = shop.shop_name;
            }
        } else if (name.startsWith('terminal_type')) {
            if (value == 3 || value == 4) {
                // 端末: カード
                // 端末: カードとQR

                // 開始日に当日を設定
                let stdt = new Date();
                applyStartDt = stdt.getFullYear() + '-' + ("0" + (stdt.getMonth() + 1)).slice(-2) + '-' + ("0" + stdt.getDate()).slice(-2);
                editing.apply_start_dt = applyStartDt;

                // 終了日に 2199年12月31日を設定
                editing.apply_stop_dt = '2199-12-31';
            }
            setTerminalType(value);
            if (value == 1) {
                disIsInstalled = false;
            } else {
                disIsInstalled = true;
            }
        }

        return value;
    }

    if (editing == null) {
        return <div></div>;
    }

    var createFlag = false;
    if (editing.is_create) {
        createFlag = true;
    }

    // 加盟店IDを設定
    // ・加盟店一覧選択時は選択した加盟店IDと加盟店名を設定
    // ・加盟店ユーザの場合はログインユーザの加盟店IDと加盟店名を設定
    editing.merchant_id = props.merchantId;
    editing.merchant_name = props.merchantName;

    // 設置フラグ
    var isInstalled = editing.is_installed == false ? 0 : 1;

    // 端末識別番号
    var terminalIdElement = "";
    if (createFlag) {
        // 新規登録時は非表示（API側にて採番）
        terminalIdElement = <div></div>;
    }
    else {
        // 編集時は表示のみ（編集不可）
        terminalIdElement =
            <Grid item xs={12}>
                <Controller
                    name="id"
                    control={control}
                    defaultValue={editing.id}
                    as={<TextField disabled required fullWidth variant="outlined"
                        label={<FormattedMessage id={"Terminal.Id"} />} />} />
            </Grid>;
    }

    // 機器設置時識別番号（端末識別番号からカラム変更）
    var installIdElement = "";

    if (editing.terminal_type == 1) {
        // ステッカー

        if (createFlag) {
            // 新規登録時は非表示（API側にて採番）
            installIdElement = <div></div>;
            editing.install_id = '';
        }
        else {
            // 編集時は表示のみ
            installIdElement =
                <Grid item xs={12}>
                    <Controller
                        name="install_id"
                        control={control}
                        defaultValue={editing.install_id}
                        as={<TextField disabled fullWidth variant="outlined"
                            label={<FormattedMessage id={"Terminal.InstallId"} />} />} />
                </Grid>;
        }
    }
    else if (editing.terminal_type == 2 || editing.terminal_type == 3 || editing.terminal_type == 4) {
        // 端末: QR
        // 端末: カード
        // 端末: カードとQR

        if (createFlag) {
            // 新規追加時は入力可能
            installIdElement =
                <Grid item xs={12}>
                    <Controller
                        name="install_id"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.install_id}
                    rules={{
                        required: <FormattedMessage id="Error.Required" />, 
                        minLength: { value: 17, message: <FormattedMessage id="Error.TerminalInstallIdPattern" /> },
                        maxLength: { value: 17, message: <FormattedMessage id="Error.TerminalInstallIdPattern" /> },
                        pattern: { value: /^M[A-Z0-9]+$/i, message: <FormattedMessage id={"Error.TerminalInstallIdPattern"} /> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.install_id && true}
                            helperText={errors.install_id ? errors.install_id.message : "例）M0000000280000003"}
                            label={<FormattedMessage id={"Terminal.InstallId"} />} />} />
                </Grid>;
        }
        else {
            // 編集時は表示のみ（編集不可）
            installIdElement =
                <Grid item xs={12}>
                    <Controller
                        name="install_id"
                        control={control}
                        defaultValue={editing.install_id}
                        as={<TextField disabled required fullWidth variant="outlined"
                            label={<FormattedMessage id={"Terminal.InstallId"} />} />} />
                </Grid>;
        }
    }

    // 機種コード
    var machineModelCdElement = "";
    if (editing.terminal_type == 1 || editing.terminal_type == 2) {
        // ステッカー
        // 端末: QR

        // 非表示
        machineModelCdElement = <div></div>;
        editing.machine_model_cd = '';
    }
    else if (editing.terminal_type == 3 || editing.terminal_type == 4) {
        // 端末: カード
        // 端末: カードとQR

        // 編集可能
        machineModelCdElement =
            <Grid item xs={12}>
                <FormControl required fullWidth variant="outlined" error={errors.machine_model_cd && true}>
                    <InputLabel id="machine-model-cd-label"><FormattedMessage id={"Terminal.MachineModelCd"} /></InputLabel>
                    <Controller
                        name="machine_model_cd"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.machine_model_cd}
                        rules={{ required: <FormattedMessage id="Error.Required" /> }}
                        as={<Select
                            labelId="machine-model-cd-label"
                            id="machine_model_cd"
                            label={<FormattedMessage id={"Terminal.MachineModelCd"} />}>
                            <MenuItem value={1071}><FormattedMessage id="Terminal.MachineModelCd.Clerk" /></MenuItem>
                            <MenuItem value={1072}><FormattedMessage id="Terminal.MachineModelCd.Customer" /></MenuItem>
                        </Select>} />
                    <FormHelperText>{errors.machine_model_cd ? errors.machine_model_cd.message : ""}</FormHelperText>
                </FormControl>
            </Grid>;
    }

    // 物販端末ID
    var machineIdElement = "";
    if (editing.terminal_type == 1 || editing.terminal_type == 2) {
        // ステッカー
        // 端末: QR

        // 非表示
        machineIdElement = <div></div>;
        editing.machine_id = '';
    }
    else if (editing.terminal_type == 3 || editing.terminal_type == 4) {
        // 端末: カード
        // 端末: カードとQR

        if (createFlag) {
            // 新規登録時は非表示
            machineIdElement = <div></div>;
            editing.machine_id = '';
        }
        else {
            // 更新時には表示のみ
            machineIdElement =
                <Grid item xs={12}>
                    <Controller
                        name="machine_id"
                        control={control}
                        defaultValue={editing.machine_id}
                        as={<TextField disabled fullWidth variant="outlined"
                            label={<FormattedMessage id={"Terminal.MachineId"} />} />} />
                </Grid>;
        }
    }

    // 有効日付
    var applyStartDateElement = "";
    var applyStopDateElement = "";
    if (editing.terminal_type == 1 || editing.terminal_type == 2) {
        // ステッカー
        // 端末: QR

        // 非表示
        applyStartDateElement = <div></div>;
        applyStopDateElement = <div></div>;
        editing.apply_start_dt = '';
        editing.apply_stop_dt = '';
    }
    else if (editing.terminal_type == 3 || editing.terminal_type == 4) {
        // 端末: カード
        // 端末: カードとQR

        // 有効日付（開始）
        var applyStartDt = ''
        if (editing.apply_start_dt != null) {
            var stdt = new Date(editing.apply_start_dt);
            applyStartDt = stdt.getFullYear() + '-' + ("0" + (stdt.getMonth() + 1)).slice(-2) + '-' + ("0" + stdt.getDate()).slice(-2);
        }
        else {
            var stdt = new Date();
            applyStartDt = stdt.getFullYear() + '-' + ("0" + (stdt.getMonth() + 1)).slice(-2) + '-' + ("0" + stdt.getDate()).slice(-2);
            editing.apply_start_dt = applyStartDt;
        }

        // 有効日付（終了）
        var applyStopDt = ''
        if (editing.apply_stop_dt != null) {
            var stdt = new Date(editing.apply_stop_dt);
            applyStopDt = stdt.getFullYear() + '-' + ("0" + (stdt.getMonth() + 1)).slice(-2) + '-' + ("0" + stdt.getDate()).slice(-2);
        }
        else {
            // 終了日に 2199年12月31日を設定
            applyStopDt = '2199-12-31';
            editing.apply_stop_dt = applyStopDt;
        }

        // ともに編集可能
        applyStartDateElement =
            <Grid item xs={6}>
                <Controller
                    name="apply_start_dt"
                    control={control}
                    onChange={onChange}
                    defaultValue={applyStartDt}
                    rules={{required: <FormattedMessage id={"Error.Required"} />}}
                    as={<TextField required fullWidth variant="outlined"
                        id="apply_start_dt"
                        type="date"
                        error={errors.apply_start_dt && true}
                        helperText={errors.apply_start_dt ? errors.apply_start_dt.message : ""}
                        label={<FormattedMessage id={"Terminal.ApplyStartDate"} />} />} />
            </Grid>;
        applyStopDateElement =
            <Grid item xs={6}>
                <Controller
                    name="apply_stop_dt"
                    control={control}
                    onChange={onChange}
                    defaultValue={applyStopDt}
                    rules={{ required: <FormattedMessage id={"Error.Required"} /> }}
                    as={<TextField required fullWidth variant="outlined"
                        id="apply_stop_dt"
                        type="date"
                        error={errors.apply_stop_dt && true}
                        helperText={errors.apply_stop_dt ? errors.apply_stop_dt.message : ""}
                        label={<FormattedMessage id={"Terminal.ApplyStopDate"} />} />} />
            </Grid>;
    }

    // チャージフラグ
    var isCharge = editing.is_charge == false ? 0 : 1;

    var chargeFlagElement = "";
    if (editing.terminal_type == 1 || editing.terminal_type == 2) {
        // ステッカー
        // 端末: QR

        // 非表示
        chargeFlagElement = <div></div>;
        // 機能なしに設定
        editing.is_charge = false;
    }
    else if (editing.terminal_type == 3 || editing.terminal_type == 4) {
        // 端末: カード
        // 端末: カードとQR

        // 編集可能
        chargeFlagElement =
            <Grid item xs={12}>
                <FormControl required fullWidth variant="outlined">
                    <InputLabel id="is-charge-label"><FormattedMessage id={"Terminal.IsCharge"} /></InputLabel>
                    <Controller
                        name="is_charge"
                        control={control}
                        onChange={onChange}
                        defaultValue={isCharge}
                        rules={{ required: <FormattedMessage id="Error.Required" /> }}
                        as={<Select
                            labelId="is-charge-label"
                            id="is-charge"
                            label={<FormattedMessage id={"Terminal.IsCharge"} />}>
                            <MenuItem value={0}><FormattedMessage id="Terminal.IsCharge.Notavailable" /></MenuItem>
                            <MenuItem value={1}><FormattedMessage id="Terminal.IsCharge.Available" /></MenuItem>
                        </Select>} />
                </FormControl>
            </Grid>;
    }

    // 端末入力チェック値
    var datePattern = /^[0-9]{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/i;
    var shopCd4Pattern = /[0-9]{6}/i;
    var shopCd4MaxLength = 6;

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <Toolbar variant="regular">
                    <div>
                        <Typography component="h1" variant="inherit">{<FormattedMessage id="Terminal.CreateTitle" />}</Typography>
                        <Typography component="h2" variant="subtitle2">{<FormattedMessage id="Terminal.CreateDesc" />}</Typography>
                    </div>
                </Toolbar>

                <form className={classes.form} noValidate>
                    <Grid container spacing={2}>
                        {terminalIdElement}
                        <Grid item xs={12}>
                            <FormControl fullWidth variant="outlined" error={errors.shop_id && true}>
                                <InputLabel id="terminal-org-label"><FormattedMessage id={"Terminal.Shop"} /></InputLabel>
                                <Controller
                                    name="shop_id"
                                    control={control}
                                    onChange={onChange}
                                    defaultValue={editing.shop_id ? editing.shop_id : ''}
                                    as={<Select
                                        labelId="terminal-shop-label"
                                        id="terminal-shop"
                                        label={<FormattedMessage id={"Terminal.Shop"} />}>
                                        <MenuItem key='' value=''>未選択</MenuItem>
                                        {
                                            editing.selectableShops.map((shop) => {
                                                return <MenuItem key={shop.id} value={shop.id}>{shop.shop_name}</MenuItem>
                                            })}
                                    </Select>} />
                                <FormHelperText>{errors.shop_id ? errors.shop_id.message : ""}</FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl required fullWidth variant="outlined" error={errors.terminal_type && true}>
                                <InputLabel id="terminal-type-label"><FormattedMessage id={"Terminal.TerminalType"} /></InputLabel>
                                <Controller
                                    name="terminal_type"
                                    control={control}
                                    onChange={onChange}
                                    defaultValue={editing.terminal_type ? editing.terminal_type : ""}
                                    rules={{ required: <FormattedMessage id="Error.Required" /> }}
                                    as={<Select
                                        disabled={!createFlag}
                                        labelId="terminal-type-label"
                                        id="terminal_type"
                                        label={<FormattedMessage id={"Terminal.TerminalType"} />}>
                                        <MenuItem value={1}><FormattedMessage id="Terminal.TerminalType.Sticker" /></MenuItem>
                                        <MenuItem value={2}><FormattedMessage id="Terminal.TerminalType.TerminalQr" /></MenuItem>
                                        <MenuItem value={3}><FormattedMessage id="Terminal.TerminalType.TerminalCard" /></MenuItem>
                                        <MenuItem value={4}><FormattedMessage id="Terminal.TerminalType.TerminalCardQr" /></MenuItem>
                                    </Select>} />
                                <FormHelperText>{errors.terminal_type ? errors.terminal_type.message : ""}</FormHelperText>
                            </FormControl>
                        </Grid>
                        {installIdElement}
                        {machineModelCdElement}
                        {machineIdElement}
                        {applyStartDateElement}
                        {applyStopDateElement}
                        {chargeFlagElement}
                        <Grid item xs={12}>
                            <Controller
                                name="shop_cd_4"
                                control={control}
                                onChange={onChange}
                                defaultValue={editing.shop_cd_4}
                                rules={{
                                    required: <FormattedMessage id="Error.Required" />,
                                    maxLength: { value: shopCd4MaxLength, message: <FormattedMessage id="Error.ShopCd4_Pattern" /> },
                                    pattern: { value: shopCd4Pattern, message: <FormattedMessage id={"Error.ShopCd4_Pattern"} /> }
                                }}
                                as={<TextField required fullWidth variant="outlined"
                                    error={errors.shop_cd_4 && true}
                                    helperText={errors.shop_cd_4 ? errors.shop_cd_4.message : "例）000000"}
                                    label={<FormattedMessage id={"Terminal.ShopCd4"} />} />} />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl required fullWidth variant="outlined">
                                <InputLabel id="is-installed-label"><FormattedMessage id={"Terminal.IsInstalled"} /></InputLabel>
                                <Controller
                                    name="is_installed"
                                    control={control}
                                    onChange={onChange}
                                    defaultValue={isInstalled}
                                    disabled={disIsInstalled}
                                    rules={{ required: <FormattedMessage id="Error.Required" /> }}
                                    as={<Select
                                        labelId="is-installed-label"
                                        id="is-installed"
                                        label={<FormattedMessage id={"Terminal.IsInstalled"} />}>
                                        <MenuItem value={0}><FormattedMessage id="Terminal.IsInstalled.Notinstalled" /></MenuItem>
                                        <MenuItem value={1}><FormattedMessage id="Terminal.IsInstalled.Installed" /></MenuItem>
                                    </Select>} />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                name="merchant_org_info"
                                control={control}
                                onChange={onChange}
                                defaultValue={editing.merchant_org_info}
                                rules={{
                                    maxLength: { value: 20, message: <FormattedMessage id="Error.TerminalMerchantOrgInfoPattern" /> }
                                }}
                                as={<TextField fullWidth variant="outlined"
                                    error={errors.merchant_org_info && true}
                                    helperText={errors.merchant_org_info ? errors.merchant_org_info.message : ""}
                                    label={<FormattedMessage id={"Terminal.MerchantOrgInfo"} />} />} />
                        </Grid>

                        <Grid container item xs={12} spacing={2} justify="center">
                            <Grid item xs={3} sm={6}>
                                <Button fullWidth variant="contained" size="medium"
                                    startIcon={<ArrowBackIosIcon />}
                                    onClick={onBackClick}><FormattedMessage id="Button.Back" /></Button>
                            </Grid>
                            <Grid item xs={3} sm={6}>
                                <Button fullWidth variant="contained" size="medium" color="primary"
                                    onClick={handleSubmit(onSubmit)}
                                    endIcon={<SaveIcon />}><FormattedMessage id="Button.Save" /></Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            </Paper>
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
            <Dialog open={conflictDlgOpen} onClose={onConflictDlgCancelClick} maxWidth="md" fullWidth>
                <DialogTitle>機器設置時識別番号の使用状況確認</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        指定した機器設置時識別番号（{conflictInfo ? conflictInfo.install_id : ''}）は以下で使用されています。
                        {isForceSwitchAllowed
                            ? '強制的に切替（旧端末を未設置化）して登録しますか？'
                            : '強制切替の実施には運営権限（システム管理者/沖縄ICカード）が必要です。運営担当者にご連絡ください。'}
                    </DialogContentText>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>加盟店名</TableCell>
                                <TableCell>店舗名</TableCell>
                                <TableCell>設置状態</TableCell>
                                <TableCell>有効期限(終了)</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {conflictInfo && conflictInfo.conflicts.map((c, idx) => (
                                <TableRow key={idx}>
                                    <TableCell>{c.merchant_name}</TableCell>
                                    <TableCell>{c.shop_name}</TableCell>
                                    <TableCell>{c.is_installed ? '設置済' : '未設置'}</TableCell>
                                    <TableCell>{c.apply_stop_dt ? c.apply_stop_dt.substring(0, 10) : ''}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </DialogContent>
                <DialogActions>
                    {isForceSwitchAllowed &&
                        <Button onClick={onForceSwitchClick} color="secondary">強制切替実施</Button>}
                    <Button onClick={onConflictDlgCancelClick} color="primary" autoFocus>キャンセル</Button>
                </DialogActions>
            </Dialog>
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(TerminalEdit);
